

































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import RegistrationFormBase from './RegistrationFormBase.vue';
import CountrySelect from '@/modules/workshops-schedule/components/CountrySelect.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

@Component({
    name: 'MarathonRegistration',
    components: {
        ValidationProvider,
        ValidationObserver,
        CountrySelect,
    },
})
export default class MarathonRegistration extends RegistrationFormBase {
    public getTranslation(key: string) {
        return this.$t(key).toString();
    }

    //#region form
    public formStep = 1;
    public sexItems = [
        { value: 1, text: this.getTranslation('userForm.male') },
        { value: 2, text: this.getTranslation('userForm.female') },
    ];
    public advanceLevelItems = [
        { value: 1, text: this.getTranslation('registrationForm.beginner') },
        { value: 2, text: this.getTranslation('registrationForm.intermediate') },
        { value: 3, text: this.getTranslation('registrationForm.advanced') },
        { value: 4, text: this.getTranslation('registrationForm.professional') },
    ];

    public dietTypeItems = [
        { value: 1, text: this.getTranslation('registrationForm.meat') },
        { value: 2, text: this.getTranslation('registrationForm.vegetarian') },
        { value: 3, text: this.getTranslation('registrationForm.vegan') },
    ];
    public arrivalDateItems = [
        { value: 1, text: this.getTranslation('registrationForm.zim2022Thursday') },
        { value: 2, text: this.getTranslation('registrationForm.zim2022Friday') },
    ];
    public departureDateItems = [
        { value: 1, text: this.getTranslation('registrationForm.zim2022Sunday') },
        { value: 2, text: this.getTranslation('registrationForm.zim2022Monday') },
    ];
    public howLongDancingItems = [
        { value: 1, text: this.getTranslation('registrationForm.lessThen1Year') },
        { value: 2, text: this.getTranslation('registrationForm.lessThen3Year') },
        { value: 3, text: this.getTranslation('registrationForm.lessThen5Year') },
        { value: 4, text: this.getTranslation('registrationForm.moreThen5Year') },
    ];
    public howMuchDancingItems = [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
        { value: 10, text: '10' },
    ];
    public tshirtSizeItems = [
        { value: 1, text: 'S' },
        { value: 2, text: 'M' },
        { value: 3, text: 'L' },
        { value: 4, text: 'XL' },
    ];

    public async mounted() {
        this.eventId = 8;
        await this.prepareForm();
    }

    protected getPosType(): string {
        return 'PayU';
    }

    public clear() {
        this.formHelper.clearRegistrationForm(this.form);
        this.acceptConditions = null;

        this.clearSelectedTickets();

        (this.$refs.observer as any).reset();
        this.formStep = 1;
    }

    public async submitRegistrationForm() {
        const observer = this.$refs.observer as any;
        const result = await observer.validate();
        const errors = observer.errors;
        if (
            errors.firstName.length ||
            errors.lastName.length ||
            errors.email.length ||
            errors.phoneNumber.length ||
            errors.sex.length
        ) {
            this.formStep = 1;
        } else if (
            errors.country.length ||
            errors.city.length ||
            errors.contactMeVia.length ||
            errors.facebook.length ||
            errors.advanceLevel.length ||
            errors.dietType.length ||
            errors.arrivalDate.length ||
            errors.departureDate.length ||
            errors.howLongDancing.length ||
            errors.howMuchDancing.length
        ) {
            this.formStep = 2;
        } else if (errors.selectedTicketsIds.length) {
            this.formStep = 3;
        }

        this.form.ParticipantData.SelectedTickets.Value = this.selectedTicketsIds;
    }

    public goToNextFormStep() {
        this.formStep = this.formStep + 1;
    }

    public goToPreviousFormStep() {
        if (this.formStep > 0) {
            this.formStep = this.formStep - 1;
        }
    }

    public onResourceLoading() {
        this.setLoading(true);
    }

    public onResourceLoadingFinished() {
        this.setLoading(false);
    }

    public async onRegistartionCreated(response: any) {
        // this.$router.currentRoute.query;
        // let path = `${window.location.origin}${window.location.pathname}${this.$router.currentRoute.fullPath}`;
        let path = `${window.location.origin}${window.location.pathname}`;
        path = path.replace('//?', '?').replace('/?', '?');

        if (response.status === 'RegistrationPaid') {
            this.cleanUrlParameters();
            this.fetchAvaiableTicketTypes();
            this.showInfo('Your registration is already paid.');

            return;
        }

        this.setFormDetails({
            eventRegistrationId: response.eventRegistrationId,
            eventRegistrationGuid: response.eventRegistrationGuid,
        });

        if (response.unavailableTicketsIds.length > 0) {
            response.unavailableTicketsIds.forEach((x: number) => this.toogleSelectedTicket(x));
            // reload the available tickets
            await this.fetchAvaiableTicketTypes();
            this.showInfo('Some of the selected tickets are not available any more. Please select tickets again.');

            return;
        }

        // const posType = this.form.ParticipantData.Country.Value === 'Poland' ? 'PayNow' : 'PayU';
        const posType = this.getPosType();

        const payment = {
            EventRegistrationId: response.eventRegistrationId,
            EventRegistrationGuid: response.eventRegistrationGuid,
            ClientIp: this.clientIp,
            PosType: posType,
            ContinueUrl: path,
        };

        const paymentResponse = await this.paymentsResource.createNewResource(payment);
        if (!paymentResponse) {
            this.showError('Error during requesting payment. Please try again or contact with the administrator.');
        }
    }
    //#endregion form
}
